'use client';

import { useEffect } from "react";
import { clarity } from "react-microsoft-clarity";

const Clarity = () => {
  useEffect(() => {
    // Check if the ID exists to prevent errors in dev/test environments
    if (process.env.NEXT_PUBLIC_CLARITY_ID) {
      clarity.init(process.env.NEXT_PUBLIC_CLARITY_ID);
    }
  }, []);

  return null;
};

export default Clarity;